// src/utils/certs.js
// Libellés de certifications, avec gestion des brevets "spéciaux" (non officiels)
// et repli propre quand une clé n'a pas de traduction (évite d'afficher
// "certifications.xxx" en brut dans l'UI).

// Brevets spéciaux attribués à la main (comptes de test, privilèges) → libellé fixe.
export const SPECIAL_CERT_LABELS = {
    silver_pinguin: "Silver Pinguin",
    bubble_blowing: "Bubble Blowing Expert",
    clarinettiste: "Clarinettiste",
};

// "bubble_blowing" → "Bubble Blowing"
const prettify = (key) =>
    String(key || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

// Retourne le libellé affichable d'un brevet.
// 1) spécial → libellé fixe ; 2) traduit → traduction ; 3) sinon → clé embellie.
export function certLabel(t, key) {
    if (SPECIAL_CERT_LABELS[key]) return SPECIAL_CERT_LABELS[key];
    const full = `certifications.${key}`;
    const translated = t(full);
    return translated === full ? prettify(key) : translated;
}
